import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  CreateUpdateIEPFacilitationDocumentDto,
  CreateUpdateIEPFacilitationDto,
  CreateUpdateIEPFacilitationPartyDto,
  IEPFacilitationDisputeDocumentDto,
  IEPFacilitationDto,
} from "../../models/dispute-resolution/iep-facilitation-models";

@Injectable({
  providedIn: "root",
})
export class IEPFacilitationService {
  private readonly baseUrl = "/api/dispute-resolution/iep-facilitation";
  private readonly partyBaseUrl = `${this.baseUrl}/parties`;
  private readonly documentBaseUrl = `${this.baseUrl}/documents`;

  constructor(private http: HttpClient) { }

  create(
    request: CreateUpdateIEPFacilitationDto
  ): Observable<IEPFacilitationDto> {
    return this.http.post<IEPFacilitationDto>(`${this.baseUrl}`, request);
  }

  getById(id: string): Observable<IEPFacilitationDto> {
    return this.http.get<IEPFacilitationDto>(`${this.baseUrl}/${id}`);
  }

  update(
    id: string,
    request: CreateUpdateIEPFacilitationDto
  ): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getAll(): Observable<IEPFacilitationDto[]> {
    return this.http.get<IEPFacilitationDto[]>(`${this.baseUrl}`);
  }

  generateCaseNumber(): Observable<string> {
    return this.http.get(`${this.baseUrl}/generate-case-number`, {
      responseType: "text",
    });
  }

  updateCaseStatus(
    disputeCaseId: string,
    workflowStatusChangesId: string
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/update-case-status/${disputeCaseId}/${workflowStatusChangesId}`,
      null
    );
  }

  updateParty(
    id: string,
    request: CreateUpdateIEPFacilitationPartyDto
  ): Observable<void> {
    return this.http.put<void>(`${this.partyBaseUrl}/${id}`, request);
  }

  createDocument(
    request: CreateUpdateIEPFacilitationDocumentDto
  ): Observable<IEPFacilitationDisputeDocumentDto> {
    return this.http.post<IEPFacilitationDisputeDocumentDto>(
      `${this.documentBaseUrl}`,
      request
    );
  }

  getDocumentsByDisputeCase(
    disputeCaseId: string
  ): Observable<IEPFacilitationDisputeDocumentDto[]> {
    return this.http.get<IEPFacilitationDisputeDocumentDto[]>(
      `${this.documentBaseUrl}/case/${disputeCaseId}`
    );
  }

  deleteDocument(id: string): Observable<void> {
    return this.http.delete<void>(`${this.documentBaseUrl}/${id}`);
  }
}
